import FadeIn from "@/components/FadeIn";
import { IMAGES } from "@/lib/site-data";

const PILLARS = [
  { label: "Curated experiences", value: "Hand-designed" },
  { label: "Luxury at better prices", value: "Direct DMC" },
  { label: "Personal curator", value: "1-on-1 service" },
  { label: "Global partners", value: "20+ countries" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <FadeIn className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden card-shadow">
              <img
                src={IMAGES.about}
                alt="DreamFly Travels group on a curated FAM trip — mountains & cable car backdrop"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:-right-8 bg-[#F4EDE4] rounded-2xl px-6 py-5 card-shadow max-w-[240px]">
              <div className="font-display text-3xl text-[#0F3D3E] leading-none">
                500+
              </div>
              <div className="mt-2 text-xs uppercase tracking-[0.18em] text-[#4B5563]">
                Happy travellers this year
              </div>
            </div>
          </div>
        </FadeIn>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <FadeIn>
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#2C7A7B]">
              <span className="h-px w-8 bg-[#2C7A7B]" />
              About DreamFly
            </div>
          </FadeIn>
          <FadeIn delay={100}>
            <h2 className="mt-5 font-display text-[#0F3D3E] text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Travel, designed around{" "}
              <span className="italic">you</span>.
            </h2>
          </FadeIn>
          <FadeIn delay={200}>
            <p className="mt-7 text-[#0A0A0A]/80 text-base sm:text-lg leading-relaxed max-w-xl">
              DreamFly Travels is an India-based travel company crafting
              international and domestic journeys that feel genuinely personal.
              From overwater villas in the Maldives to safari drives across the
              Serengeti, we handle every detail — flights, stays, visas,
              transfers and on-ground support — so you can focus on the
              memories.
            </p>
          </FadeIn>
          <FadeIn delay={300}>
            <p className="mt-4 text-[#0A0A0A]/70 text-base leading-relaxed max-w-xl">
              Our promise is simple: luxury travel at sensible prices, delivered
              with transparency and a single curator from first enquiry to
              welcome-home.
            </p>
          </FadeIn>

          <FadeIn delay={400}>
            <div className="mt-10 grid grid-cols-2 gap-5 max-w-xl">
              {PILLARS.map((p) => (
                <div
                  key={p.label}
                  data-testid={`about-pillar-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="rounded-2xl border border-[#0F3D3E]/10 bg-white p-5 hover:border-[#2C7A7B]/40 transition-colors"
                >
                  <div className="font-display text-xl text-[#0F3D3E]">
                    {p.value}
                  </div>
                  <div className="mt-1 text-xs uppercase tracking-[0.15em] text-[#4B5563]">
                    {p.label}
                  </div>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
